<template>
  <div :class="['el-chunk', modifiers]">
    <div class="emd-mode-switcher">
      <input
        data-testid="switch-theme-mode-input"
        class="emd-mode-switcher__input"
        type="checkbox"
        id="modeToggle"
        :checked="isDark"
        :value="value"
        @change="handleChange"
      >
      <label data-testid="switch-theme-mode-label" class="emd-mode-switcher__toggle" for="modeToggle">
        <span class="emd-mode-switcher__left-text">AM</span>
        <div class="emd-mode-switcher__area">
          <div class="emd-mode-switcher__indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <span class="emd-mode-switcher__right-text">PM</span>
      </label>
    </div>
  </div>
</template>
<script>
const body = document.body

export default {
  name: 'EmdSwitchThemeMode',
  props: {
    value: {
      type: String
    },
    position: {
      type: String,
      require: false,
      default: undefined
    },
    align: {
      type: String,
      required: false,
      default: undefined
    },
    isDark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    modifiers () {
      const classes = []
      if (this.position) {
        classes.push(`eu-position_${this.position}`)
      }
      if (this.align) {
        classes.push(`eu-align_${this.align}`)
      }
      return classes
    }
  },
  methods: {
    handleChange (e) {
      if (e.target.checked) {
        body.classList.add('_mode_dark')
      } else {
        body.classList.remove('_mode_dark')
      }
      const mode = e.target.checked ? 'dark' : 'light'
      this.$emit('input', e.target.checked, mode)
    }
  },
  beforeMount: function () {
    if (this.isDark) {
      body.classList.add('_mode_dark')
    } else {
      body.classList.remove('_mode_dark')
    }
  }
}
</script>
